import { defineStore } from 'pinia';

interface ISystemState {
  session: boolean;
  accessUser: boolean;
  accessRole: boolean;
}

export const useSystemStore = defineStore('system', {
  state: (): ISystemState => ({
    session: true,
    accessUser: true,
    accessRole: true,
  }),

  getters: {
    isCloseSession: (state) => !state.session,
    isBlockUser: (state) => !state.accessUser,
    isBlockRole: (state) => !state.accessRole,
  },

  actions: {
    setSession(data = false) {
      this.session = data;
    },
    setAccessUser(data = false) {
      this.accessUser = data;
    },
    setAccessRole(data = false) {
      this.accessRole = data;
    },
  },
});

export default useSystemStore;
